import script from "./CustomerFitnessHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerFitnessHistory.vue?vue&type=script&setup=true&lang=js"

import "./CustomerFitnessHistory.vue?vue&type=style&index=0&id=d957380e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d957380e"]])

export default __exports__